import { ActivityStatus, LanguageCode } from '@sparted/shared-library/business/types';
import { t } from 'i18next';

import { getLanguagesAvailableWithCode } from 'Services/language/languageService';
import { Activity } from 'Store/entities/activity/activity.type';

export const legacyActivityTypeIdMap: Record<Activity['type'], number> = {
  campaign: 1,
  'breaking-news': 4,
};

type AudienceType = 'all' | 'group' | 'magic_code' | 'email_list';

export const audienceModeTypeIdToAudienceType = (audienceModeTypeId: number): AudienceType => {
  switch (audienceModeTypeId) {
    case 1:
      return 'magic_code';
    case 2:
      return 'email_list';
    case 3:
      return 'group';
    default:
      return 'all';
  }
};

export const mapLegacyActivityTypeToActivityType = (legacyActivityType: number): Activity['type'] | undefined => {
  switch (legacyActivityType) {
    case 1:
      return 'campaign';
    case 4:
      return 'breaking-news';
  }
};

export const mapActivityStatusLabel = (status: ActivityStatus): string => {
  switch (status) {
    case 'draft':
      return t('activities:list.item.status.draft');
    case 'inactive':
      return t('activities:list.item.status.inactive');
    case 'archived':
      return t('activities:list.item.status.archived');
    case 'upcoming':
      return t('activities:list.item.status.upcoming');
    case 'live':
      return t('activities:list.item.status.live');
    case 'finished':
    case 'celebration':
      return t('activities:list.item.status.finished');
  }
};

export const mapLegacyActivityStatusId = (statusId: number): Activity['status'] => {
  switch (statusId) {
    case -2:
      return 'archived';
    case 1:
      return 'upcoming';
    case 2:
      return 'live';
    case 3:
      return 'finished';
    case 4:
      return 'inactive';
    default:
      return 'draft';
  }
};

export const mapLanguageIdsToLanguageCodes = (languageIds: number[]): LanguageCode[] => {
  const languages = getLanguagesAvailableWithCode();

  const codes = languageIds.map((id) => {
    const language = languages.find((lang) => lang.id === id);

    return language?.languageCode;
  });

  return codes.filter(Boolean) as LanguageCode[];
};
